import "./main.scss";
export const Banner = ({ isDashboardBanner }) => {
  return (
    <div className={`banner ${isDashboardBanner && "banner__dashboard"}`}>
      <p className="banner__text">
        <strong>Disclaimer:</strong> This site is a clone and is not affiliated with the real&nbsp;
        <a href="https://www.todoist.com" className="banner__link">
          todoist.com
        </a>
      </p>
    </div>
  );
};
